import React, {useState} from 'react';
import './styles.scss';
import AppFooter from '../app-footer';
import {Column, Row} from '../layout';
import AppNavMenu from '../app-nav-menu';
import * as fonts from '../../util/fonts';
import AppUserLogout from '../app-userlogout/AppUserLogout';
import {compose} from 'redux';
import {connect, useSelector} from 'react-redux';
import Banner from '../../containers/homepage/banners/Banner';
import NewAppHeader from '../headers/app-header/NewAppHeader';
import AppLanguageSelector from '../app-language-selector/AppLanguageSelector';
import {useRedirectUrl} from '../../contexts/RedirectUrlContext';
import {createGUID} from '../../util/utility';
import {strings} from '../../util/strings';
import {useAppNavMenuItems, useAppWrapperState, useBanners} from './hooks';

interface AppWrapperProps {
  children: React.ReactNode;
  user: {
    state: string;
  };
  labels: typeof strings.pt.menu;
  selectedBu: {
    buId: string;
    memId: string;
  };
  busStyles: Array<{
    buId: string;
    urlLogout?: string;
  }>;
  tenant: any;
}

function AppWrapper({
  children,
  user,
  labels,
  selectedBu,
  busStyles,
  tenant,
}: AppWrapperProps) {
  const appNavMenuId = createGUID();
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);
  const {setUrl} = useRedirectUrl();

  const strings = useSelector((state: any) => state.strings.value);

  const items = useAppNavMenuItems(strings, tenant);
  const {campaigns, hideBanner, bannersEmpty} = useBanners(selectedBu);
  const {updateImages, inHomePage} = useAppWrapperState(
    selectedBu,
    busStyles,
    setUrl
  );

  return (
    <Column className="app-wrapper-main-column">
      <NewAppHeader
        hideBanner={hideBanner}
        updateImages={updateImages}
        inHomePage={inHomePage}
        responsiveMenuItems={items}
      />

      {window.location.pathname === '/inicio' && !bannersEmpty && (
        <Banner campaigns={campaigns} enableBanner={!hideBanner} />
      )}

      <Column
        className={
          bannersEmpty
            ? 'app-wrapper-container-no-banners'
            : 'app-wrapper-container'
        }
        style={{...fonts.M}}>
        <Row className="app-wrapper-row">
          {/* {user.state === 'CLIENT' && ( */}
          <AppNavMenu key={appNavMenuId} items={items} />
          {/* )} */}
          <AppUserLogout setShowLanguageSelector={setShowLanguageSelector} />
        </Row>
      </Column>

      {children}

      <div className="app-wrapper-footer-wrapper">
        <AppFooter updateImages={updateImages} />
      </div>

      <AppLanguageSelector
        show={showLanguageSelector}
        setShow={setShowLanguageSelector}
      />
    </Column>
  );
}

const mapStateToProps = ({
  user,
  strings,
  selectedBu,
  busStyles,
  tenant,
}: any) => ({
  user: user.value,
  labels: strings.value.pt.menu,
  selectedBu: selectedBu.value,
  busStyles: busStyles.value,
  tenant: tenant.value,
});

export default compose(connect(mapStateToProps)(AppWrapper));
